import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductosPage = lazy(() => import('../pages/productos/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const UbicacionPage = lazy(() => import('../pages/ubicacion/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/productos',
    element: <ProductosPage />
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '/ubicacion',
    element: <UbicacionPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
